export default __webpack_public_path__ + "static/media/AcornMallFastFood_00.07429487.png";